import { Box, Flex, Group, Text, Title } from '@mantine/core'
import { Elements } from '@stripe/react-stripe-js'
import {
    CreditCard,
} from 'lucide-react'

import ModalHeader from '@/modules/Cart/shared/ModalHeader/ModalHeader'
import { WithViewModelProps } from '@/shared/types/components'

import { stripePromise } from '../../../Cart'

import CardForm from './CardForm/CardForm'
import { useViewModel } from './PaymentForm.vm'
import PromoCodeInput from '../PromoCodeInput/PromoCodeInput'

export const PaymentFormTitle = () => {
    const metadata = {
        title: 'Paiement',
        description: 'Sélectionnez une option de paiement.',
    }
    return <ModalHeader {...metadata} />
}

export const PaymentForm = () => {
    const viewModel = useViewModel()

    return <PaymentFormView viewModel={viewModel} />
}

const PaymentFormView = ({
    viewModel,
}: WithViewModelProps<typeof useViewModel>) => (
    <Box className="p-4">
        <Flex>
            <Group spacing="xs">
                <CreditCard />
                <Title order={5}>Méthode de paiement</Title>
                <Text size="xs" c="gray.6">
                    C'est ici que vous allez entrer vos informations de
                    paiement.
                </Text>
            </Group>
        </Flex>

        {viewModel.canShowPaymentForm && (
            <Elements
                options={{
                    locale: 'fr-FR',
                    clientSecret: viewModel.clientSecret,
                }}
                stripe={stripePromise}
            >
                <CardForm
                    billing_address={viewModel.paymentBillingAdress!}
                    client_secret={viewModel.clientSecret}
                />
            </Elements>
        )}
    </Box>
)
